class DesignSummaryComponent extends HTMLElement {
  connectedCallback() {
    this.innerHTML = String.raw`
      <div id="design-summary-div" class="d-none">

        <div class="row mt-3" style="max-width: 900px;">
          <div class="col-12">
            <div id="design-summary-panel" class="card card-success">
              <div id="design-summary-heading" class="card-header">
                <h4>
                  <span class="current-design-status float-start">Design OK</span>
                  <span class="float-end">
                    <span id="design-summary-load-combination"> LRFD - </span>
                    <span id="design-summary-shape"> W8X15 - </span>
                    <span id="design-summary-material">A992</span>
                  </span>
                </h4>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3" style="max-width: 900px;"> 

          <div class="col-6">
            <div id="bending-design-panel" class="card card-success">
              <div class="card-header">
                <h4 class="panel-title">
                  <span class="float-start">Bending</span>
                  <span class="float-end">0.49</span>
                </h4>
              </div>
              <div class="card-body"></div>
            </div>
          </div>

          <div class="col-6">
            <div id="shear-design-panel" class="card card-success">
              <div class="card-header">
                <h4 class="panel-title">
                  <span class="float-start">Shear</span>
                  <span class="float-end">0.12</span>
                </h4>
              </div>
              <div class="card-body"></div>
            </div>
          </div>

        </div>

        <div class="row mt-3" style="max-width: 900px;">

          <div class="col-6">
            <div id="deflection-design-panel" class="card card-success">
              <div class="card-header">
                <h4 class="panel-title">
                  <span class="float-start">Deflection</span>
                  <span class="float-end">0.83</span></h3>
              </div>
              <div class="card-body"></div>
            </div>
          </div>

          <div class="col-6">
            <div id="design-info-summary-panel" class="card card-success">
              <div class="card-header">
                <h4 class="panel-title">Design Info</h4>
              </div>
              <div class="card-body"></div>
            </div>
          </div>
        </div>

      </div>
      `
  }
}

customElements.define('design-summary', DesignSummaryComponent);